import { req } from 'vuelidate/lib/validators/common'
import { withParams } from 'vuelidate'
import Moment from 'moment'

export default withParams({ type: 'isRegex' }, value =>
    !req(value)
    || Moment(value, 'MM/YYYY', true).isValid()
    || Moment(value, 'MM/YY', true).isValid()
);
